import { PessoaEndereco } from './endereco';
import { PessoaContato } from './contato';

export class PessoaEnderecoContato {
    endereco: PessoaEndereco;
    contato: PessoaContato;

    constructor(endereco: PessoaEndereco,contato: PessoaContato) {
        this.endereco = endereco;
        this.contato = contato;
    }
}
